<template>
  <div class="resizable-container">
    <!-- 左侧可拖动区域 -->
    <div class="left-panel" :style="{ width: leftWidth + 'px' }">
      <el-tree ref="treeRef" style="height: 96%;overflow: auto;" node-key="id" :data="treedata" highlight-current
        :props="defaultProps" @node-click="handleNodeClick">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;" src="@/assets/img/图标/folder.svg" />
          <span class="node-label">{{ node.label }}</span>
        </span>

      </el-tree>

    </div>

    <!-- 拖动手柄 -->
    <div class="resizer" @mousedown="startDrag" :class="{ 'active': isDragging }">
      <div class="resizer-handle"></div>
    </div>

    <!-- 右侧区域 -->
    <div class="right-panel">
      <el-container>
        <el-header>
          <el-row>
            <el-col :span="20">
              <el-button type="primary" icon="el-icon-plus" size="mini" @click="AddMyDocumentTree()">{{ $t('我的资料.新建文件夹')
              }}</el-button>

              <el-dropdown style="margin: 0 8px;" @command="handleCommand">
                <el-button icon="el-icon-upload2" size="mini" type="plain">
                  {{ $t('我的资料.上传') }}
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="文件" v-if="selectNode.id">{{ $t('我的资料.文件') }}</el-dropdown-item>
                  <el-dropdown-item command="文件夹">{{ $t('我的资料.文件夹') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-button type="plain" size="mini" icon="el-icon-rank" @click="bathMove()">{{ $t('我的资料.移动到')
              }}</el-button>
              <!-- <el-button type="plain">复制到</el-button> -->
              <el-button type="plain" size="mini" icon="el-icon-download" @click="bathDownload()">{{ $t('我的资料.下载')
              }}</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="bathchDelete()">{{
                $t('我的资料.删除') }}</el-button>
            </el-col>
            <el-col :span="4">
              <el-input size="mini" :placeholder="$t('我的资料.请输入文件名称关键词')" v-model="searchword" @input="searchChange">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-col>
          </el-row>
        </el-header>
        <el-main>
          <p style="margin: -30px 0 10px 0;width: 94%;display: inline-block;">
            <el-button type="text" @click="home()" class="el-icon-s-home"
              style="margin-right: 5px;font-size: 16px;"></el-button>
            <el-button type="text" :style="{
              fontWeight: selectNode.id == item.id ? 'bold' : 'normal',
              margin: 0,
              fontSize: '15px',
              color: selectNode.id == item.id ? 'black' : 'rgb(0, 53, 101)'
            }" v-for="(item, index) in breadcrumbData" @click="breadcrumbClick(item)" :key="index">{{ (index ==
              breadcrumbData.length - 1) ? item.name :
              item.name + "/" }}</el-button>
          </p>

          <el-dropdown>
            <el-button size="mini">
              <span v-html="currentSort.label"></span>
            </el-button>

            <el-dropdown-menu>
              <!-- 遍历数据列表 -->
              <el-dropdown-item v-for="(item, index) in sortOptions" :key="index" @click.native="handleSort(item)">
                <!-- 使用 #default 插槽渲染 HTML -->
                <template #default>
                  <span v-html="item.label"></span>
                </template>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>


          <div class="rygl-table">
            <el-table ref="multipleTable" header-row-class-name="headerClass" border highlight-current-row
              :data="fileTableData" tooltip-effect="dark" style="width: 100%" height="72vh"
              @selection-change="SelectionChange" v-loading="tableLoading">
              <el-table-column align="center" type="selection"></el-table-column>
              <el-table-column prop="name" :label="$t('我的资料.文件名称')">
                <template slot-scope="scope">

                  <div v-if="scope.row.isFolder">
                    <el-button type="text"
                      style="width: 100%; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 20px;text-align: left;"
                      @click="breadcrumbClick(scope.row)">
                      <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;" src="@/assets/img/图标/folder.svg" />
                      {{ scope.row.name }}
                    </el-button>
                  </div>
                  <div v-else>
                    <div v-if="exts.indexOf(scope.row.ext) > -1">
                      <!-- <el-tooltip effect="dark" :content="scope.row.name" placement="bottom-start"> -->
                      <el-button type="text" @click="documentOpen(scope.row)"
                        style="width: 100%; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 20px;text-align: left;">
                        <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;"
                          :src="documentIcon(scope.row.ext)" />{{
                            scope.row.name }}
                      </el-button>
                      <!-- </el-tooltip> -->
                    </div>
                    <div style="display: flex; align-items: center; width: 100%; white-space: nowrap;"
                      v-else-if="modelexts.indexOf(scope.row.ext) > -1">
                      <i v-if="scope.row.modelstate == 1 || scope.row.modelstate == null" class="el-icon-view"
                        :title="$t('我的资料.点击转换')"
                        :style="{ marginRight: '8px', cursor: 'pointer', color: scope.row.modelstate == 1 ? 'red' : 'black' }"
                        @click="transformfilemodel(scope.row)"></i>
                      <i v-if="scope.row.modelstate == 0" class="el-icon-loading" :title="$t('我的资料.转换中请稍等')"></i>
                      <!-- <el-tooltip effect="dark" :content="scope.row.name + '(' + (
                        scope.row.modelstate == null ? $t('我的资料.未转换') :
                          scope.row.modelstate == 0
                            ? $t('我的资料.转换中')
                            : scope.row.modelstate == 1
                              ? $t('我的资料.转换失败')
                              : scope.row.modelstate == 2
                                ? $t('我的资料.转换成功')
                                : '--')
                        + ')'" placement="bottom-start"> -->
                      <el-button type="text" @click="documentOpen(scope.row)"
                        style="flex: 1; overflow: hidden; text-overflow: ellipsis;text-align: left;">
                        <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;"
                          :src="documentIcon(scope.row.ext)" />
                        {{ scope.row.name }}
                        <span :style="{
                          color:
                            scope.row.modelstate == 0
                              ? '#e6a23c'
                              : scope.row.modelstate == 1
                                ? '#f56c6c'
                                : scope.row.modelstate == 2
                                  ? '#67c23a'
                                  : 'black',
                        }">
                        </span>
                      </el-button>
                      <!-- </el-tooltip> -->
                    </div>
                    <span v-else>
                      <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;" :src="documentIcon(scope.row.ext)" />
                      {{ scope.row.name }}
                    </span>
                  </div>

                </template>
              </el-table-column>

              <el-table-column align="center" :label="$t('我的资料.操作')" width="100">
                <template slot-scope="scope">

                  <el-popover placement="left" width="400" trigger="click">

                    <div style="display: flex;">
                      <el-input v-model="scope.row.editname"></el-input>
                      <el-button type="primary" style="margin-left:10px;" @click="editname(scope.row, scope.$index)">{{
                        $t('common.确定') }}</el-button>
                      <el-button @click="() => {
                        scope.row.editname = scope.row.name
                        $refs['editButton' + scope.$index].$el.click()
                      }">{{ $t('common.取消') }}</el-button>
                    </div>
                    <el-button size="small" :ref="'editButton' + scope.$index" type="text" style="cursor: pointer"
                      icon="el-icon-edit" slot="reference"></el-button>

                  </el-popover>


                  <el-button size="small" type="text" style="cursor: pointer" icon="el-icon-download"
                    @click="download(scope.row)"></el-button>

                </template>
              </el-table-column>


              <el-table-column align="center" prop="MB" width="100" :label="$t('我的资料.文件大小')"></el-table-column>

              <el-table-column align="center" width="150" prop="creteTime" :label="$t('我的资料.更新时间')"></el-table-column>

            </el-table>
          </div>
          <!-- 文件上传 -->
          <el-upload v-show="false" ref="uploadRef" :action="actionUrl" :file-list="fileList" :auto-upload="true"
            :data="aaa" :headers="importHeaders" :multiple="true" :on-progress="onProgress" :on-success="onSuccess"
            :on-error="onError">
            <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
          </el-upload>
          <!-- 文件夹上传 -->
          <input ref="folderInput" type="file" webkitdirectory multiple @change="onFolderSelect"
            style="display: none" />


          <!-- 上传进度 -->
          <MyDialog :initialPosition="initPosition" @update:visible="() => {
            uploadingFiles = [];
            dialogVisible = false
          }" :height="350" :width="500" :visible="dialogVisible" :title="$t('我的资料.上传列表')">
            <el-tabs v-model="activeName">
              <el-tab-pane :label="`${$t('我的资料.上传中')}(${uploadingFiles.filter(w => w.status == undefined).length})`"
                name="first">
                <div v-for="file in uploadingFiles.filter(w => w.status == undefined)" :key="file.uid"
                  style="margin: 10px 0;">
                  <div>{{ file.name }}</div>
                  <el-progress :percentage="file.percentage" :status="file.status" :stroke-width="8"></el-progress>
                  <div style="font-size: 12px; color: #666;">
                    {{ $t('我的资料.状态') }}: {{ getStatusText(file.status) }} - {{ file.percentage }}%
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="`${$t('我的资料.上传成功')}(${uploadingFiles.filter(w => w.status == 'success').length})`"
                name="second">
                <div v-for="file in uploadingFiles.filter(w => w.status == 'success')" :key="file.uid"
                  style="margin: 10px 0;">
                  <div>{{ file.name }}</div>
                  <el-progress :percentage="file.percentage" :status="file.status" :stroke-width="8"></el-progress>
                  <div style="font-size: 12px; color: #666;">
                    {{ $t('我的资料.状态') }}: {{ getStatusText(file.status) }} - {{ file.percentage }}%
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="`${$t('我的资料.上传失败')}(${uploadingFiles.filter(w => w.status == 'exception').length})`"
                name="third">
                <div v-for="file in uploadingFiles.filter(w => w.status == 'exception')" :key="file.uid"
                  style="margin: 10px 0;">
                  <div>{{ file.name }}</div>
                  <el-progress :percentage="file.percentage" :status="file.status" :stroke-width="8"></el-progress>
                  <div style="font-size: 12px; color: #666;">
                    {{ $t('我的资料.状态') }}: {{ getStatusText(file.status) }} - {{ file.percentage }}%
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>





          </MyDialog>


          <MyDialog @update:visible="() => {
            selectNode2 = {};
            dialogVisible2 = false
          }" :height="500" :visible="dialogVisible2" :title="$t('我的资料.移动到')">
            <el-tree style="height: 90%;" ref="treeRef2" node-key="id" :data="treedata" highlight-current
              :props="defaultProps" @node-click="handleNodeClick2">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;" src="@/assets/img/图标/folder.svg" />
                <span class="node-label">{{ node.label }}</span>
              </span>
            </el-tree>
            <el-row style="margin-top: 10px;">
              <el-col :span="6" :offset="6">
                <el-button type="primary" data-placement="bottom" size="small" @click="moveSubmit">{{ $t('common.确定')
                }}</el-button>
              </el-col>
              <el-col :span="6" :offset="3">
                <el-button data-placement="bottom" size="small" @click="() => {
                  selectNode2 = {};
                  dialogVisible2 = false
                }"> {{ $t('common.取消') }}</el-button>
              </el-col>
            </el-row>
          </MyDialog>


        </el-main>
      </el-container>
    </div>
  </div>

</template>

<script>
import {
  AddOrUpdateMyDocumentTree,
  AddOrUpdateMyDocument,
  DownLoadMyDocument,
  GetMyDocumentTree,
  GetMyDocument,
  UploadMyDocument,
  transformmydocument,
  AddRecentlyFile,
  DelMyDocument
} from "@/setAxios.js";
import * as tools from "@/tools/tool";
import MyDialog from "@/components/Customization/dialog/index";
import dayjs from "dayjs";
export default {
  components: { MyDialog },
  name: 'myData',
  data() {
    return {
      activeName: "first",
      //#region 拖动相关变量

      leftWidth: 200, // 左侧初始宽度
      isDragging: false, // 是否正在拖动
      startX: 0, // 拖动开始时的鼠标X坐标
      startWidth: 0, // 拖动开始时的左侧宽度
      rafId: null, // requestAnimationFrame ID
      minWidth: 200, // 最小宽度
      //#endregion


      //#region 
      searchword: '',
      treedata: [],
      selectNode: {},
      selectNode2: {},
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      fileAllTableData: [],
      fileTableData: [],
      //面包屑数据
      breadcrumbData: [],
      //文件夹数据
      folderData: [],
      documentList: [],
      tableLoading: false,
      importHeaders: { token: localStorage.getItem("token") },
      aaa: {
        xid: localStorage.getItem("xid"),
      },
      fileList: [],
      uploadingFiles: [], // 存储正在上传的文件进度
      actionUrl: this.$store.state.baseUrl + "/api/UploadMyDocument",
      uploadingFiles: [],
      dialogVisible: false,
      dialogVisible2: false,
      initPosition: { x: window.innerWidth - 500, y: 550 },
      exts: [
        "png",
        "jpg",
        "jpeg",
        "mp4",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "ppt",
        "pptx",
        "txt",
        "gif",
        "pdf",
      ],
      modelexts: [
        "nwd", "nwf", "nwc",
        "rvt", "rfa",
        "model", "session", "exp", "dlw3", "catpart", "catproduct", "cgr",
        "dgn", "prp", "prw",
        "dwg", "dxf",
        "fbx", "ifc", "3dm", "skp",
        "prt", "sldprt", "asm", "sldasm"
      ],
      selectList: [],
      //#endregion
      sortOptions: [
        { name: '名称降序', label: `${this.$t('排序.名称')} <i class='el-icon-bottom' style='color:red'></i>` },
        { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
        { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
        { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
      ],
      currentSort: { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
    };
  },
  computed: {
    rightWidth() {
      return window.innerWidth - this.leftWidth - 30; // 减去容器边距和分隔条宽度
    }
  },
  created() {
    this.GetMyDocumentTree();
  },
  methods: {

    //#region 排序相关方法

    handleSort(item) {
      this.currentSort = item;
      if (item.name == '名称升序') {
        this.sortOptions = [
          { name: '名称降序', label: `${this.$t('排序.名称')} <i class='el-icon-bottom' style='color:red'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '名称降序') {
        this.sortOptions = [
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '时间升序') {
        this.sortOptions = [
          { name: '时间降序', label: `${this.$t('排序.时间')} <i class='el-icon-bottom' style='color:red'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '时间降序') {
        this.sortOptions = [
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '类型升序') {
        this.sortOptions = [
          { name: '类型降序', label: `${this.$t('排序.类型')} <i class='el-icon-bottom' style='color:red'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '类型降序') {
        this.sortOptions = [
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '大小升序') {
        this.sortOptions = [
          { name: '大小降序', label: `${this.$t('排序.大小')} <i class='el-icon-bottom' style='color:red'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
        ]
      } else if (item.name == '大小降序') {
        this.sortOptions = [
          { name: '大小升序', label: `${this.$t('排序.大小')} <i class='el-icon-top'></i>` },
          { name: '名称升序', label: `${this.$t('排序.名称')} <i class='el-icon-top'></i>` },
          { name: '时间升序', label: `${this.$t('排序.时间')} <i class='el-icon-top'></i>` },
          { name: '类型升序', label: `${this.$t('排序.类型')} <i class='el-icon-top'></i>` },
        ]
      }
      this.handelSort()
    },
    //执行排序
    handelSort() {
      var folderData = this.fileTableData.filter(item => item.isFolder);
      var fileData = this.fileTableData.filter(item => !item.isFolder);
      if (this.currentSort.name == '名称升序') {
        folderData = this.nameSortMethod(folderData, 'ascending');
        fileData = this.nameSortMethod(fileData, 'ascending');
      } else if (this.currentSort.name == '名称降序') {
        folderData = this.nameSortMethod(folderData, 'descending');
        fileData = this.nameSortMethod(fileData, 'descending');
      } else if (this.currentSort.name == '时间升序') {
        folderData = this.sortArrayByTime(folderData, 'creteTime', 'ascending');
        fileData = this.sortArrayByTime(fileData, 'creteTime', 'ascending');
      } else if (this.currentSort.name == '时间降序') {
        folderData = this.sortArrayByTime(folderData, 'creteTime', 'descending');
        fileData = this.sortArrayByTime(fileData, 'creteTime', 'descending');
      } else if (this.currentSort.name == '类型升序') {
        // folderData = this.extSortMethod(folderData, 'ascending');
        fileData = this.extSortMethod(fileData, 'ascending');
      } else if (this.currentSort.name == '类型降序') {
        // folderData = this.extSortMethod(folderData, 'descending');
        fileData = this.extSortMethod(fileData, 'descending');
      } else if (this.currentSort.name == '大小升序') {
        fileData = this.numberSortMethod(fileData, 'size', 'ascending');
      } else if (this.currentSort.name == '大小降序') {
        fileData = this.numberSortMethod(fileData, 'size', 'descending');
      }

      this.fileTableData = [...folderData, ...fileData]
    },


    //文件类型排序
    extSortMethod(data, order, fieldConfig = {}) {
      const { nameField1 = 'name', nameField2 = 'name' } = fieldConfig;

      // 创建排序比较器
      const collator = new Intl.Collator('zh-CN', {
        numeric: true,
        sensitivity: 'base',
        caseFirst: 'lower',
        usage: 'sort'
      });

      // 提取主名（忽略后缀）
      const getBaseName = (item) => {
        const name = item[nameField1] || item[nameField2] || '';
        if (!name) return '';

        const lastDotIndex = name.lastIndexOf('.');
        if (lastDotIndex > 0 && lastDotIndex < name.length - 1) {
          return name.slice(lastDotIndex);
        }
        return name;
      };

      // 复制数组并排序
      return [...data].sort((a, b) => {
        const baseA = getBaseName(a);
        const baseB = getBaseName(b);
        let compare = collator.compare(baseA, baseB);
        return order === 'ascending' ? compare : -compare;
      });
    },

    // 文件大小排序
    numberSortMethod(arr, orderKey, order) {
      const newArr = [...arr];
      return newArr.sort((a, b) => {
        // 容错：处理时间字段为空/无效的情况，默认排到最后
        const timeA = a[orderKey] || 0;
        const timeB = b[orderKey] || 0;

        return order === 'descending' ? (timeB - timeA) : (timeA - timeB);
      });

    },
    //时间排序
    sortArrayByTime(arr, timeKey, order) {
      // 浅拷贝原数组，避免修改原数据
      console.log(arr);
      const newArr = [...arr];
      return newArr.sort((a, b) => {
        // 容错：处理时间字段为空/无效的情况，默认排到最后
        const timeA = a[timeKey] ? new Date(a[timeKey]).getTime() : 0;
        const timeB = b[timeKey] ? new Date(b[timeKey]).getTime() : 0;

        return order === 'descending' ? (timeB - timeA) : (timeA - timeB);
      });
    },

    /**
     * 按照Windows 11规则排序对象数组（忽略文件后缀）
     * @param {Array} data - 要排序的对象数组
     * @param {string} order - 排序方向：'ascending' 或 'descending'
     * @param {Object} fieldConfig - 字段配置（可选）
     * @param {string} fieldConfig.nameField1 - 第一个名字字段名，默认 'prfl02'
     * @param {string} fieldConfig.nameField2 - 第二个名字字段名，默认 'pftr02'
     * @returns {Array} - 排序后的新数组
     */
    nameSortMethod(data, order, fieldConfig = {}) {
      console.log(data);
      const { nameField1 = 'name', nameField2 = 'name' } = fieldConfig;

      // 创建排序比较器
      const collator = new Intl.Collator('zh-CN', {
        numeric: true,
        sensitivity: 'base',
        caseFirst: 'lower',
        usage: 'sort'
      });

      // 提取主名（忽略后缀）
      const getBaseName = (item) => {
        const name = item[nameField1] || item[nameField2] || '';
        if (!name) return '';

        const lastDotIndex = name.lastIndexOf('.');
        if (lastDotIndex > 0 && lastDotIndex < name.length - 1) {
          return name.slice(0, lastDotIndex);
        }
        return name;
      };

      // 复制数组并排序
      return [...data].sort((a, b) => {
        const baseA = getBaseName(a);
        const baseB = getBaseName(b);
        let compare = collator.compare(baseA, baseB);
        return order === 'ascending' ? compare : -compare;
      });
    },

    //#endregion

    //#region 拖动相关方法
    // 开始拖动
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startWidth = this.leftWidth;

      // 绑定鼠标移动和释放事件到document（避免鼠标移出手柄时失效）
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);

      // 防止拖动时选中文本
      e.preventDefault();
    },

    // 拖动中 - 使用requestAnimationFrame优化性能
    onDrag(e) {
      if (!this.isDragging) return;

      // 使用requestAnimationFrame优化性能
      if (!this.rafId) {
        this.rafId = requestAnimationFrame(() => {
          const newWidth = this.startWidth + (e.clientX - this.startX);

          // 限制最小和最大宽度
          if (newWidth >= this.minWidth && newWidth <= window.innerWidth - 700) {
            this.leftWidth = newWidth;
          }

          this.rafId = null;
        });
      }
    },

    // 结束拖动
    stopDrag() {
      this.isDragging = false;

      // 移除事件监听
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);

      // 取消动画帧
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    },

    // 更新最大宽度（响应窗口大小变化）
    updateMaxWidth() {
      this.maxWidth = window.innerWidth - 200;
    },

    //#endregion


    //#region left content
    searchChange() {
      if (this.searchword != '')
        this.fileTableData = this.fileAllTableData.filter(item => item.name.includes(this.searchword))
      else
        this.fileTableData = this.fileAllTableData
    },
    breadcrumbClick(data) {
      var treeNode = this.$refs.treeRef.getNode(data.id);
      this.handleNodeClick(data, treeNode)
      this.$refs.treeRef.setCurrentKey(data.id);

      // 展开当前节点
      treeNode.expanded = true;

      // 递归展开所有父节点
      let parent = treeNode.parent;
      while (parent && parent.level > 0) { // 排除根节点
        parent.expanded = true;
        parent = parent.parent;
      }

    },
    // 自定义方法：获取节点的完整路径
    getNodePath(node) {
      const path = [];
      let current = node;

      while (current && current.data) {
        path.unshift(current.data);
        // 关键修复：检查是否是真正的根节点，避免重复
        if (current.parent && current.parent.level === 0) {
          break; // 遇到树根就停止
        }
        current = current.parent;
      }

      return path;
    },
    home() {
      this.selectNode = {};
      this.breadcrumbData = [];
      this.folderData = this.treedata
      this.$refs.treeRef.setCurrentKey();
      this.GetMyDocument();
    },
    GetMyDocumentTree() {
      GetMyDocumentTree({
        uid: localStorage.getItem("id"),
        xid: localStorage.getItem("xid")
      }).then(res => {
        if (res.Data.length) {
          res.Data.forEach(v => {
            v.isFolder = true;
            v.editname = v.name
          })
          this.treedata = this.buildTree(res.Data);
          this.folderData = this.treedata;
          if (this.selectNode.id) {
            this.$nextTick(() => {
              this.breadcrumbClick(this.selectNode)
            });
          } else {
            this.GetMyDocument();
          }
        }
      })
    },
    AddMyDocumentTree() {
      this.$prompt(this.$t('我的资料.请输入文件夹名称'), this.$t('我的资料.新建文件夹'), {
        confirmButtonText: this.$t('common.确定'),
        cancelButtonText: this.$t('common.取消'),
        inputPattern: /^[\u4e00-\u9fa5a-zA-Z0-9_\-\s\.]+$/,
        inputErrorMessage: this.$t('我的资料.文件夹名称不符合规范')
      }).then(({ value }) => {
        AddOrUpdateMyDocumentTree({
          userId: localStorage.getItem("id"),
          xid: localStorage.getItem("xid"),
          name: value,
          parentId: this.selectNode.id || 0
        }).then(res => {
          if (res.Code) {

            this.GetMyDocumentTree()
          } else {
            this.$message.error(this.$t('我的资料.文件夹重复'))

          }
        })
      })

    },
    handleNodeClick(data, node) {
      this.selectNode = data;
      this.aaa.treeId = data.id;
      this.breadcrumbData = [];
      this.breadcrumbData = this.getNodePath(node);
      this.folderData = node.childNodes.map(item => item.data);
      this.GetMyDocument();
    },

    handleNodeClick2(data) {
      this.selectNode2 = data;
    },

    /**
     * 将扁平数据构建成树形结构，并清理空的 children 字段
     * @param {Array} flatData - 扁平数据数组
     * @param {String} idField - 节点唯一标识字段名
     * @param {String} parentIdField - 父节点标识字段名
     * @returns {Array} 树形结构数组
     */
    buildTree(flatData, idField = 'id', parentIdField = 'parentId') {
      const map = {};
      const tree = [];

      // 构建映射关系
      flatData.forEach(item => {
        map[item[idField]] = { ...item, children: [] };
      });

      // 构建树结构
      flatData.forEach(item => {
        const id = item[idField];
        const parentId = item[parentIdField];

        if (parentId && map[parentId]) {
          map[parentId].children.push(map[id]);
        } else {
          tree.push(map[id]);
        }
      });

      // 清理空的 children 字段
      function removeEmptyChildren(node) {
        if (node.children && node.children.length === 0) {
          delete node.children;
        } else if (node.children) {
          node.children.forEach(removeEmptyChildren);
        }
      }

      tree.forEach(removeEmptyChildren);

      return tree;
    },
    //#endregion

    //#region right content
    bathchDelete() {
      if (this.selectList.length == 0) {
        this.$message.error(this.$t('common.请先选择'))
        return;
      }
      const loading = window.ElementUI.Loading.service({
        lock: false,
        text: localStorage.lang == 'zh' ? '处理中，请稍候...' : ' Please wait a moment...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)'
      });
      DelMyDocument({
        list: this.selectList.map(item => {
          return {
            id: item.id,
            isFolder: item.isFolder || false,
          }
        }), isHide: 1
      }).then(res => {
        loading.close();
        if (res.Code) {
          this.$message.success(this.$t('common.处理成功'))
          this.GetMyDocumentTree()
        } else {
          this.$message.error(res.Message)
        }
      }).catch(err => {
        loading.close();
        this.$message.error(err.Message)
      })
    },
    editname(row, index) {
      const regex = /^[\u4e00-\u9fa5a-zA-Z0-9_\-\s\.]+$/;
      if (!regex.test(row.editname)) {
        this.$message.error(this.$t('我的资料.文件夹名称不符合规范'))
        return
      }
      if (row.isFolder) {
        AddOrUpdateMyDocumentTree({ ...row, name: row.editname, createTime: new Date() }).then(res => {
          if (!res.Code) {
            this.$message.error(this.$t('我的资料.文件夹重复'))
          } else {
            row.name = row.editname
            this.$refs['editButton' + index].$el.click()
            this.$message.success(this.$t('common.处理成功'))
          }
        })
      } else {
        row.name = row.editname;
        row.createTime = new Date()
        AddOrUpdateMyDocument(row).then(res => {
          if (res.Code) {
            this.$refs['editButton' + index].$el.click()
            this.$message.success(this.$t('common.处理成功'))
          }
        })
      }
    },

    async documentOpen(item) {
      AddRecentlyFile({ fileId: item.guid, userId: this.$store.state.uid, time: dayjs().format("YYYY-MM-DD HH:mm:ss") })
      let params = `fileId=${item.guid}&path=${item.path}&xid=${item.xid}&name=${item.name}`;
      params = Base64.encode(params);
      let url = window.location.origin + `/#/viewMyDocument?Code=${params}`;
      window.open(url, "_blank");
    },
    async transformfilemodel(data) {
      data.modelstate = 0
      let res = await transformmydocument(data);
      if (res.Code)
        this.$message({
          type: "success",
          message: this.$t('我的资料.成功')
        })
      else
        this.$message({
          type: "error",
          message: res.Message
        })
      this.GetMyDocument()
    },

    /**
     * 多文件上传进度处理
     */
    onProgress(event, file, fileList) {
      this.dialogVisible = true;
      // 更新或添加文件进度
      const existingFileIndex = this.uploadingFiles.findIndex(f => f.uid === file.uid);

      if (existingFileIndex > -1) {
        // 更新已存在的文件进度
        this.uploadingFiles[existingFileIndex].percentage = Math.round(event.percent);
        this.uploadingFiles[existingFileIndex].status = undefined;
      } else {
        // 添加新文件进度
        this.uploadingFiles.push({
          uid: file.uid,
          name: file.name,
          percentage: Math.round(event.percent),
          status: undefined,
          raw: file
        });
      }

      // 实时更新文件列表中的进度
      this.fileList = fileList;
    },

    /**
     * 上传成功处理
     */
    onSuccess(response, file, fileList) {

      // 更新进度状态为成功
      const fileIndex = this.uploadingFiles.findIndex(f => f.uid === file.uid);
      if (fileIndex > -1) {
        this.uploadingFiles[fileIndex].percentage = 100;
        this.uploadingFiles[fileIndex].status = 'success';
      }
      this.GetMyDocument();
      // 3秒后移除成功的文件
      // setTimeout(() => {
      //   this.uploadingFiles = this.uploadingFiles.filter(f => f.uid !== file.uid);
      // }, 3000);
    },

    /**
     * 上传失败处理
     */
    onError(error, file, fileList) {
      const fileIndex = this.uploadingFiles.findIndex(f => f.uid === file.uid);
      if (fileIndex > -1) {
        this.uploadingFiles[fileIndex].percentage = 0;
        this.uploadingFiles[fileIndex].status = 'exception';
      }
    },

    /**
     * 获取状态文本
     */
    getStatusText(status) {
      const statusMap = {
        uploading: this.$t('我的资料.上传中'),
        success: this.$t('我的资料.上传成功'),
        exception: this.$t('我的资料.上传失败')
      };
      return statusMap[status] || this.$t('我的资料.上传中');
    },
    SelectionChange(val) {
      this.selectList = val;
    },
    download(row) {
      const loading = window.ElementUI.Loading.service({
        lock: false,
        text: localStorage.lang == 'zh' ? '下载中，请稍候...' : 'Downloading... Please wait a moment...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)'
      });
      DownLoadMyDocument([{
        id: row.id,
        isFolder: row.isFolder || false,
      }]).then(res => {
        loading.close();
        if (res.Code) {
          const url = this.$store.state.baseUrl + res.Data;
          if (res.otherData)
            tools.download(url, res.otherData);
          else
            tools.downloadURL(url);
        } else {
          this.$message.error(res.Message)
        }
      }).catch(err => {
        loading.close();
        this.$message.error(err.Message)
      })
    },
    bathMove() {
      if (this.selectList.length == 0) {
        this.$message.error(this.$t('common.请先选择'))
        return;
      }
      this.dialogVisible2 = true;
    },
    moveSubmit() {
      if (this.selectList.filter(item => item.isFolder && item.id == this.selectNode2.id).length) {
        this.$message.error(this.$t('我的资料.不能移动到当前目录下'))
        return;
      }
      //选择文件移动时必须选择目标文件夹
      if (!this.selectNode2.id && this.selectList.some(w => !w.isFolder)) {
        this.$message.error(this.$t('我的资料.选择文件移动时必须选择目标文件夹'))
        return;
      }
      var count = 0;
      this.selectList.forEach(item => {
        item.parentId = this.selectNode2.id || 0;
        item.treeId = this.selectNode2.id || 0;
        item.creteTime = new Date();
        if (item.isFolder) {
          AddOrUpdateMyDocumentTree(item).then(res => {
            if (res.Code == 0) {
              this.$message.error(item.name + `  ${this.$t('我的资料.移动失败当前目录下已有此名称')}`)
            }
            count = count + 1;
          });
        } else {
          AddOrUpdateMyDocument(item).then(res => {
            count = count + 1;
          });
        }
      });
      var timer = setInterval(() => {
        if (count == this.selectList.length) {
          this.$message.success(this.$t('common.处理成功'))
          this.dialogVisible2 = false;
          // this.selectNode2 = {}
          this.GetMyDocumentTree()
          // this.GetMyDocument()
          clearInterval(timer);
        }
      }, 500);
    },
    bathDownload() {
      if (this.selectList.length == 0) {
        this.$message.error(this.$t('common.请先选择'))
        return;
      }
      const loading = window.ElementUI.Loading.service({
        lock: false,
        text: localStorage.lang == 'zh' ? '下载中，请稍候...' : 'Downloading... Please wait a moment...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)'
      });
      DownLoadMyDocument(this.selectList.map(item => {
        return {
          id: item.id,
          isFolder: item.isFolder || false,
        }
      })).then(res => {
        loading.close();
        if (res.Code) {
          const url = this.$store.state.baseUrl + res.Data;
          if (res.otherData)
            tools.download(url, res.otherData);
          else
            tools.downloadURL(url);
        } else {
          this.$message.error(res.Message)
        }
      }).catch(err => {
        loading.close();
        this.$message.error(err.Message)
      })
    },
    handleCommand(command) {
      if (command == '文件') {
        this.$refs.uploadRef.$refs['upload-inner'].handleClick();
      } else {
        // 上传文件夹
        this.$refs.folderInput.click();
      }
    },
    //#region  文件夹上传
    /**
     * 文件夹选择处理
     */
    onFolderSelect(event) {
      const files = Array.from(event.target.files);

      // 检查是否选择了文件夹
      if (files.length === 0) return;

      // 验证是否为文件夹（通过 webkitRelativePath）
      const hasFolderStructure = files.some(file => file.webkitRelativePath);

      if (!hasFolderStructure) {
        this.$message.warning('请选择文件夹，而不是单个文件');
        return;
      }
      this.dialogVisible = true;

      this.handleFolderUpload(files);

      // 重置 input，允许重复选择
      event.target.value = '';
    },

    /**
    * 处理文件夹上传
    */
    async handleFolderUpload(files) {
      this.isUploading = true;
      this.uploadingFiles = [];

      // 初始化上传列表
      files.forEach(file => {
        this.uploadingFiles.push({
          uid: this.generateUid(),
          name: file.name,
          relativePath: file.webkitRelativePath,
          size: file.size,
          percentage: 0,
          status: undefined
        });
      });

      try {
        // 分批上传，避免同时上传太多文件
        for (let i = 0; i < files.length; i++) {
          var file = files[i]
          await this.uploadSingleFile(file, i)
        }
        this.GetMyDocumentTree();
      } catch (error) {
        this.$message.error('上传失败: ' + error.message);
      } finally {
        this.isUploading = false;
      }
    },

    /**
     * 上传单个文件
     */
    uploadSingleFile(file, index) {
      return new Promise((resolve, reject) => {
        // 更新状态为上传中
        this.uploadingFiles[index].status = undefined;

        const formData = new FormData();
        formData.append('files', file);
        formData.append('xid', localStorage.xid);
        formData.append('treeId', this.selectNode.id || 0)
        // 实际的上传代码（取消注释并使用）

        UploadMyDocument(formData, {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            this.uploadingFiles[index].percentage = percent;
          }
        }).then(response => {
          this.uploadingFiles[index].percentage = 100;
          this.uploadingFiles[index].status = 'success';
          resolve(response.Data);
        }).catch(error => {
          this.uploadingFiles[index].status = 'exception';
          reject(error);
        });

      });
    },

    /**
     * 从路径中提取文件夹名称
     */
    extractFolderName(relativePath) {
      if (!relativePath) return '未知文件夹';
      return relativePath.split('/')[0];
    },

    /**
     * 生成唯一ID
     */
    generateUid() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2);
    },
    //#endregion

    documentIcon(ext) {
      switch (ext) {
        case "png":
        case "jpg":
        case "jpeg":
          return require('@/assets/img/图标/jpg.svg')
        case "dwg":
        case "dxf":
          return require('@/assets/img/图标/dwg.svg')
        case "mp4":
          return require('@/assets/img/图标/视频.svg')
        case "docx":
        case "doc":
          return require('@/assets/img/图标/doc.svg')
        case "xlsx":
        case "xls":
          return require('@/assets/img/图标/xls.svg')
        case "rvt":
        case "rfa":
          return require('@/assets/img/图标/rvt.svg')
        case "skp":
          return require('@/assets/img/图标/skp.svg')
        case "txt":
          return require('@/assets/img/图标/txt.svg')
        case "pdf":
          return require('@/assets/img/图标/pdf.svg')
        default:
          return require('@/assets/img/图标/文档.svg')
      }
    },
    GetMyDocument() {
      this.tableLoading = true;
      GetMyDocument({
        treeId: this.selectNode.id || 0,
        xid: localStorage.getItem("xid")
      }).then(res => {
        this.tableLoading = false;
        this.fileTableData = []
        if (this.folderData) {
          this.fileTableData = this.folderData;
        }
        if (res.Data) {
          res.Data.forEach(item => {
            item.editname = item.name
          });
          this.fileTableData = this.fileTableData.concat(res.Data);
        }
        this.fileAllTableData = JSON.parse(JSON.stringify(this.fileTableData));
        this.handelSort()
      })
    },
    //#endregion




  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.updateMaxWidth);
    this.updateMaxWidth();
  },
  beforeDestroy() {
    // 组件销毁前确保移除事件监听，防止内存泄漏
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
    window.removeEventListener('resize', this.updateMaxWidth);

    // 取消动画帧
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-tree-node__content {
  padding-top: 2px;
  /* 内容区域上边距 */
  padding-bottom: 2px;
  /* 内容区域下边距 */
}

/deep/ .headerClass>th {
  background-color: rgb(247, 249, 255);
  border-bottom-color: rgb(235, 238, 245)
}

/deep/.upload-dialog {
  position: absolute !important;
  ;
  right: 1% !important;
  bottom: 5% !important;
}

/deep/.el-dropdown-menu__item {
  color: black;
  background: #fff;

  &:hover {
    color: #ffbb37;
    background-color: black;
  }
}

/deep/ .el-dropdown-menu,
.el-popper,
.el-dropdown-menu--small {
  background-color: white !important;
}

/deep/ .popper__arrow::after {
  border-bottom-color: #FFFFFF !important;
}


/deep/ .el-dropdown-menu,
.el-dropdown-menu__item--divided {
  border-top: none;

  &::before {
    content: "";
    height: 6px;
    display: block;
    margin: 0 -20px;
    background-color: white !important;
  }
}


.el-dropdown-menu {
  background-color: #1f2d3d;
}

/deep/ .el-dropdown-menu,
.el-dropdown-menu__item--divided {
  border-top: none;

  &::before {
    content: "";
    height: 6px;
    display: block;
    margin: 0 -20px;
    background-color: rgb(25, 36, 49);
  }
}

.resizable-container {
  display: flex;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.left-panel {
  height: 100%;
  background-color: #f8f9fa;
  padding: 20px;
  overflow: auto;
  min-width: 200px;
  transition: none;
  /* 移除过渡效果，避免拖动时卡顿 */
}

.right-panel {
  flex: 1;
  height: 100%;
  background-color: #ffffff;
  padding: 20px;
  overflow: auto;
}

.resizer {
  width: 8px;
  height: 100%;
  background-color: #e9ecef;
  cursor: col-resize;
  user-select: none;
  position: relative;
  z-index: 10;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resizer:hover,
.resizer.active {
  background-color: #4dabf7;
}

.resizer-handle {
  width: 4px;
  height: 60px;
  background-color: #adb5bd;
  border-radius: 2px;
  transition: background-color 0.2s;
}

.resizer:hover .resizer-handle,
.resizer.active .resizer-handle {
  background-color: #fff;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .resizable-container {
    height: 500px;
  }

}
</style>